import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';
import Icon from '@kurtosys/ksys-app-components/dist/components/base/Icon';

export default InjectedStyledComponent(Icon, 'assurance', ['iconComponent']);